let instance;
class BrowserPropertyValidator {
  browserProps = {};

  constructor() {
    if (instance) return instance;
    this.browserProps = {};
    instance = this;
  }

  eachVendor(prop, fn) {
    var prefixes = ["Webkit", "Moz", "ms", "O"];
    var i = 0;
    var l = prefixes.length;
    fn(prop);
    for (; i < l; i++) {
      fn(prefixes[i] + prop.charAt(0).toUpperCase() + prop.slice(1));
    }
  }

  check(property, testValue) {
    var sandbox = document.createElement("iframe");
    var el = document.createElement("p");
    var support;

    document.body.appendChild(sandbox);
    sandbox.contentDocument.body.appendChild(el);
    support = this.set(el, property, testValue);

    // We have to do this because remove() is not supported by IE11 and below
    sandbox.parentElement.removeChild(sandbox);
    return support;
  }

  checkComputed(el, prop) {
    var computed = window.getComputedStyle(el).getPropertyValue(prop);
    return computed !== void 0 && computed.length > 0 && computed !== "none";
  }

  set(el, prop, value) {
    var match = false;
    if (this.browserProps[prop] === void 0) {
      this.eachVendor(
        prop,
        function(vendorProp) {
          if (el.style[vendorProp] !== void 0 && match === false) {
            el.style[vendorProp] = value;
            if (this.checkComputed(el, vendorProp)) {
              match = true;
              this.browserProps[prop] = vendorProp;
            }
          }
        }.bind(this)
      );
    } else {
      el.style[this.browserProps[prop]] = value;
      return true;
    }
    return match;
  }
}

export default BrowserPropertyValidator;
